<template>
    <div class="pa-0 flex-grow-1 d-flex flex-column" fluid style="width:100%;">
        <v-layout row align-center :class="`flex-grow-0 d-flex`" v-if="showNavigationAndFilters">
            <v-flex shrink class="px-1">
                <ForecastingOverviewCalendarWeekPicker 
                    :value="selectedDate"
                    @input="onDateSelected">
                </ForecastingOverviewCalendarWeekPicker>
            </v-flex>
            <v-flex grow class="subheading font-weight-bold info--text px-1">
                <span>{{ activeWeekDescription }}</span>
            </v-flex>
            <v-flex shrink>
                <v-btn color="primary" v-if="showYieldValues" @click="selectAllYields" :disabled="allYieldedCropCount == 0">
                    {{isAllYieldedCropSelected ? "Unselect": "Select"}} All (TY)
                </v-btn>
            </v-flex>
            <v-flex shrink>
                <v-btn color="primary" v-if="showProfileValues" @click="selectAllProfiles" :disabled="allProfiledCropCount == 0">
                    {{isAllProfiledCropSelected ? "Unselect": "Select"}} All (P)
                </v-btn>
            </v-flex>
            <v-flex shrink>
                <v-btn color="primary" v-if="showYieldValues || showProfileValues" :disabled="forecastWeeksYieldApplied.length == 0 && forecastWeeksProfileApplied.length == 0" @click="copySelectedYieldsProfiles">
                    Copy Selected
                </v-btn>
            </v-flex>
            <v-flex shrink>
                <v-flex shrink>
                    <v-checkbox hide-details color="primary" v-model="profileValues" label="Show Profile values" @change="toggleProfileValues()" class="mt-0"></v-checkbox>
                    <v-checkbox hide-details color="primary" v-model="yieldValues" label="Show The Yield values" @change="toggleYieldValues()" class="mt-0"></v-checkbox>
                    <v-checkbox hide-details color="primary" v-model="allActiveLocations" label="Show all active locations" @change="toggleActiveLocations()" class="mt-0"></v-checkbox>
                </v-flex>
            </v-flex>
            <v-flex shrink class="text-lg-right px-1">
                <ForecastingOverviewCalendarNavigation 
                    :value="selectedCalendarMode" 
                    @input="onSetSelectedCalendarMode">
                </ForecastingOverviewCalendarNavigation>
            </v-flex>
        </v-layout>
        <v-layout row align-center :class="`flex-grow-0 d-flex`">
            <v-flex grow class="subheading font-weight-bold info--text px-1">
                <v-btn small block flat @click="toggleNavigationAndFilters">
                    <span v-if="showNavigationAndFilters">Hide Controls</span>
                    <span v-else>Show Controls</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout row class="flex-grow-1 d-flex ma-0">
            <v-flex class="flex-grow-1 d-flex" style="position:relative; height:100%; width:100%;">
                <ForecastingOverviewCalendarDay 
                    v-if="isDayMode"  
                    :forecastWeeksYieldApplied="forecastWeeksYieldApplied"
                    :forecastWeeksProfileApplied="forecastWeeksProfileApplied"
                    @onYieldsApplied="onYieldsApplied"
                    @onProfilesApplied="onProfilesApplied"
                    @applyWeekYield="applyWeekYield"
                    @applyWeekProfile="applyWeekProfile"
                    @goToDetail="$emit('goToDetail', $event)"
                    @IncrementDate="onDateIncrement($event)">
                </ForecastingOverviewCalendarDay>
                <ForecastingOverviewCalendarWeek 
                    v-else-if="isWeekMode"
                    @onDateSelected="onDateSelected"
                    @onYieldsApplied="onYieldsApplied"
                    @onProfilesApplied="onProfilesApplied"
                    @applyWeekYield="applyWeekYield"
                    @applyWeekProfile="applyWeekProfile"
                    :forecastWeeksYieldApplied="forecastWeeksYieldApplied"
                    :forecastWeeksProfileApplied="forecastWeeksProfileApplied"
                    @goToDetail="$emit('goToDetail', $event)">
                </ForecastingOverviewCalendarWeek>
            </v-flex>
            <v-dialog
                v-model="batchUpdating"
                persistent
                width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Bulk updating
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import ForecastingOverviewCalendarModes from '@/helpers/forecastingOverviewCalendarModes'
import ForecastingOverviewCalendarNavigation from '@/components/forecasting/ForecastingOverviewCalendarNavigation.vue'
import ForecastingOverviewCalendarWeekPicker from '@/components/forecasting/ForecastingOverviewCalendarWeekPicker.vue'
import ForecastingOverviewCalendarDay from '@/components/forecasting/ForecastingOverviewCalendarDay.vue'
import ForecastingOverviewCalendarWeek from '@/components/forecasting/ForecastingOverviewCalendarWeek.vue'
import ForecastingUtilService from '@/services/forecastingUtilService';
import ForecastingDistributionService from '@/services/forecastingDistributionService'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex"
import momentCache from "@/services/momentCache"

export default {
    components: {
        ForecastingOverviewCalendarNavigation,
        ForecastingOverviewCalendarWeekPicker,
        ForecastingOverviewCalendarDay,
        ForecastingOverviewCalendarWeek,
    },
    props: {

    },
    data(){
        return {
            forecastWeeksYieldApplied: [],
            forecastWeeksProfileApplied: [],
            batchUpdating: false,
            profileValues: false,
            yieldValues: false,
            allActiveLocations: false,
        };
    },
    watch: {
        filterDivisionIds() {
            this.forecastWeeksYieldApplied = [];
            this.forecastWeeksProfileApplied = [];
            console.log("filterDivisionIds");
        },
        filterVarietyIds() {
            this.forecastWeeksYieldApplied = [];
            this.forecastWeeksProfileApplied = [];
            console.log("filterVarietyIds");
        }
    },
    computed: {
        ...mapGetters("ForecastingStore", [
            "startOfSelectedWeek",
        ]),
        ...mapState("ForecastingStore", [
            "selectedDate",
            "financialYearCalendarData",
            "selectedPlantId",
            "selectedCategoryId",
            "selectedCalendarMode",
            "showNavigationAndFilters",
            "showYieldValues",
            "showProfileValues",
            "showAllActiveLocations",
            "detailedWeeks",
            "calendarSortedItems",
            "filterDivisionIds",
            "filterVarietyIds"
        ]),
        activeWeekDescription(){
            var financialWeek = ForecastingUtilService.getFinancialWeek(this.selectedDate, this.financialYearCalendarData);

            return `Active WEEK ${financialWeek} - ${this.$options.filters.formatDate(momentCache.createMoment(this.selectedDate).startOf('week'))} - ${this.$options.filters.formatDate(momentCache.createMoment(this.selectedDate).endOf('week'))}`;
        },
        isDayMode(){
            return this.selectedCalendarMode == ForecastingOverviewCalendarModes.Day;
        },
        isWeekMode(){
            return this.selectedCalendarMode == ForecastingOverviewCalendarModes.Week;
        },
        canReview() {
            return true;
        },
        isTabletMode(){
            return this.$vuetify.breakpoint.mdAndDown;
        },
        isAllYieldedCropSelected() {
            // For this week, the number of crops have yield week value
            var allYieldedCropCount = this.allYieldedCropCount;
            // For this week, the number of crops have been selected to apply yield value into forecast value
            var allCheckedYieldedCropCount = this.forecastWeeksYieldApplied.length;
            return allYieldedCropCount == allCheckedYieldedCropCount && allYieldedCropCount.length != 0;
        },
        allYieldedCropCount() {
             // For this week, the number of crops have yield week value
            var allYieldedCropCount = 0;

            this.detailedWeeks
            .filter(w=> !w.locked)
            .filter(w=> this.selectedCalendarMode == ForecastingOverviewCalendarModes.Week || w.week == this.startOfSelectedWeek)
            .forEach(detailedWeek=> {
                allYieldedCropCount = allYieldedCropCount + detailedWeek.yieldedCrops.length;
            })
            return allYieldedCropCount;
        },
        isAllProfiledCropSelected() {
            // For this week, the number of crops have a profile week value
            var allProfiledCropCount = this.allProfiledCropCount;
            // For this week, the number of crops have been selected to apply yield value into forecast value
            var allCheckedProfiledCropCount = this.forecastWeeksProfileApplied.length;
            return allProfiledCropCount == allCheckedProfiledCropCount && allProfiledCropCount.length != 0;
        },
        allProfiledCropCount() {
             // For this week, the number of crops have yield week value
            var allProfiledCropCount = 0;

            this.detailedWeeks
            .filter(w=> !w.locked)
            .filter(w=> this.selectedCalendarMode == ForecastingOverviewCalendarModes.Week || w.week == this.startOfSelectedWeek)
            .forEach(detailedWeek=> {
                allProfiledCropCount = allProfiledCropCount + detailedWeek.profiledCrops.length;
            })
            return allProfiledCropCount;
        }
    },
    methods: {
        ...mapMutations("ForecastingStore", [
            "setSelectedDate",
            "setSelectedCalendarMode",
            "setShowNavigationAndFilters",
            "setShowProfileValues",
            "setShowYieldValues",
            "setShowAllActiveLocations",
        ]),
        ...mapActions("ForecastingStore", [
            "loadCropVarieties",
            "handleForecastsChanged",
            "updateData"
        ]),
        toggleProfileValues(){
            this.setShowProfileValues(this.profileValues);
        },
        toggleYieldValues(){
            this.setShowYieldValues(this.yieldValues);
        },
        toggleNavigationAndFilters(){
            this.setShowNavigationAndFilters(!this.showNavigationAndFilters);
        },
        async toggleActiveLocations() {
            this.setShowAllActiveLocations(this.allActiveLocations)
            await this.updateData();
        },
        async onDateIncrement(value){
            var newDate = this.$options.filters.formatDateYMD( momentCache.createMoment(this.selectedDate).add(value, 'w'));
            this.onDateSelected(newDate)
        },
        async onDateSelected(date) {
            this.setSelectedDate(date);
            await this.loadCropVarieties();
            await this.updateData();
            this.forecastWeeksYieldApplied = [];
            this.forecastWeeksProfileApplied = [];
        },
        onYieldsApplied(forecastWeek) {
            var index = this.forecastWeeksYieldApplied.findIndex(f=> f.week == forecastWeek.week && f.cropLocationId == forecastWeek.cropLocationId && f.varietyId == forecastWeek.varietyId);
            if(index > -1) {
                this.forecastWeeksYieldApplied.splice(index, 1);
            } else {
                this.forecastWeeksYieldApplied.push(forecastWeek);
            }
        },
        selectAllYields() {
            if(!this.isAllYieldedCropSelected) {
                this.forecastWeeksYieldApplied = [];
                this.detailedWeeks
                .filter(w=> !w.locked)
                .filter(w=> this.selectedCalendarMode == ForecastingOverviewCalendarModes.Week || w.week == this.startOfSelectedWeek)
                .forEach(detailedWeek=> {
                    detailedWeek.yieldedCrops.forEach(yc=> {
                        this.forecastWeeksYieldApplied.push({week: detailedWeek.week, cropLocationId: yc.cropLocationId, varietyId: yc.varietyId});
                    })
                })
            } else { 
                this.forecastWeeksYieldApplied = [];
            }
        },
        onProfilesApplied(forecastWeek) {
            var index = this.forecastWeeksProfileApplied.findIndex(f=> f.week == forecastWeek.week && f.cropLocationId == forecastWeek.cropLocationId && f.varietyId == forecastWeek.varietyId);
            if(index > -1) {
                this.forecastWeeksProfileApplied.splice(index, 1);
            } else {
                this.forecastWeeksProfileApplied.push(forecastWeek);
            }
        },
        selectAllProfiles() {
            if(!this.isAllProfiledCropSelected) {
                this.forecastWeeksProfileApplied = [];
                this.detailedWeeks
                .filter(w=> !w.locked)
                .filter(w=> this.selectedCalendarMode == ForecastingOverviewCalendarModes.Week || w.week == this.startOfSelectedWeek)
                .forEach(detailedWeek=> {
                    detailedWeek.profiledCrops.forEach(yc=> {
                        this.forecastWeeksProfileApplied.push({week: detailedWeek.week, cropLocationId: yc.cropLocationId, varietyId: yc.varietyId});
                    })
                })
            } else { 
                this.forecastWeeksProfileApplied = [];
            }
        },
        async copySelectedYieldsProfiles() {
            try {
                this.batchUpdating = true;
                var bulkUpdateForecasts = [];
                var forecastDays = [];
                this.forecastWeeksYieldApplied.forEach(w=> {
                    let calendarSortedItem = this.calendarSortedItems.find(csi => csi.cropLocationId == w.cropLocationId && csi.varietyId == w.varietyId);
                    if(calendarSortedItem) {
                        let forecastWeek = calendarSortedItem.forecastWeeks.find(fw=> fw.week == w.week);
                        if(forecastWeek) {
                            if(!forecastWeek.locked) {
                                let dayValues = ForecastingDistributionService.getNewDayValuesForForecastWeek(
                                    forecastWeek.totalYields, 
                                    forecastWeek.forecastDays,
                                    forecastWeek.week
                                );
                                for(let i = 0; i < dayValues.length; i++){
                                    var modifiedForecast = ForecastingUtilService.modifyForecastValue(
                                        dayValues[i].day, 
                                        dayValues[i].newValue, 
                                        forecastWeek.forecastDays, 
                                        false,
                                        w.cropLocationId,
                                        w.varietyId
                                    );
                                    if(modifiedForecast != null){
                                        bulkUpdateForecasts.push(modifiedForecast);
                                    }
                                }
                                forecastDays = forecastDays.concat(forecastWeek.forecastDays);
                            }
                        }
                    }
                });

                this.forecastWeeksProfileApplied.forEach(w=> {
                    let calendarSortedItem = this.calendarSortedItems.find(csi => csi.cropLocationId == w.cropLocationId && csi.varietyId == w.varietyId);
                    if(calendarSortedItem) {
                        let forecastWeek = calendarSortedItem.forecastWeeks.find(fw=> fw.week == w.week);
                        if(forecastWeek) {
                            if(!forecastWeek.locked) {
                                let dayValues = ForecastingDistributionService.getNewDayValuesForForecastWeek(
                                    forecastWeek.totalProfiles, 
                                    forecastWeek.forecastDays,
                                    forecastWeek.week
                                );
                                for(let i = 0; i < dayValues.length; i++){
                                    var modifiedForecast = ForecastingUtilService.modifyForecastValue(
                                        dayValues[i].day, 
                                        dayValues[i].newValue, 
                                        forecastWeek.forecastDays, 
                                        false,
                                        w.cropLocationId,
                                        w.varietyId
                                    );
                                    if(modifiedForecast != null){
                                        bulkUpdateForecasts.push(modifiedForecast);
                                    }
                                }
                                forecastDays = forecastDays.concat(forecastWeek.forecastDays);
                            }
                        }
                    }
                });

                await this.handleForecastsChanged({
                    forecasts: bulkUpdateForecasts
                });
            
                await this.updateData({all: false, forecastDays: forecastDays});
                // await this.loadCropVarieties();
                // await this.updateData();
                this.forecastWeeksYieldApplied = [];
                this.forecastWeeksProfileApplied = [];
                this.batchUpdating = false;
            } catch(e) {
                 alert("Bulk update error " + e.toString());
            } finally {
                this.batchUpdating = false;
            }
        },
        applyWeekYield(detailedWeek) {
            // For this week, the number of crops have yield week value
            var allYieldedCropCount = detailedWeek.yieldedCrops.length;

            // For this week, the number of crops have been selected to apply yield value into forecast value
            var allCheckedYieldedCropCount = this.forecastWeeksYieldApplied.filter(f=> f.week == detailedWeek.week).length;

            // If above two count is not the same, it means it is to check all
            var isCheck = allYieldedCropCount != allCheckedYieldedCropCount;
            
            detailedWeek.yieldedCrops.forEach(yc=> {
                 var index = this.forecastWeeksYieldApplied.findIndex(f=> f.week == yc.week && f.cropLocationId == yc.cropLocationId && f.varietyId == yc.varietyId);
                 
                 // There is existing crop for the week checked, if the action is to un check (isCheck false), we will remove the item
                 if(index > -1) {
                     if(!isCheck) {
                         this.forecastWeeksYieldApplied.splice(index ,1);
                     } 
                 } 
                 // There is no existing crop for the week checked, if the action is check (isCheck true), we will add the item to it
                 else {
                     if(isCheck) {
                        this.forecastWeeksYieldApplied.push(yc);
                     }
                 }
            })
        },
        applyWeekProfile(detailedWeek) {
            // For this week, the number of crops have a profile week value
            var allProfiledCropCount = detailedWeek.profiledCrops.length;

            // For this week, the number of crops have been selected to apply a profile value into the forecast value
            var allCheckedProfileCropCount = this.forecastWeeksProfileApplied.filter(f=> f.week == detailedWeek.week).length;

            // If above two count is not the same, it means it is to check all
            var isCheck = allProfiledCropCount != allCheckedProfileCropCount;
            
            detailedWeek.profiledCrops.forEach(yc=> {
                 var index = this.forecastWeeksProfileApplied.findIndex(f=> f.week == yc.week && f.cropLocationId == yc.cropLocationId && f.varietyId == yc.varietyId);
                 
                 // There is existing crop for the week checked, if the action is to un check (isCheck false), we will remove the item
                 if(index > -1) {
                     if(!isCheck) {
                         this.forecastWeeksProfileApplied.splice(index ,1);
                     } 
                 } 
                 // There is no existing crop for the week checked, if the action is check (isCheck true), we will add the item to it
                 else {
                     if(isCheck) {
                        this.forecastWeeksProfileApplied.push(yc);
                     }
                 }
            })
        },
        onSetSelectedCalendarMode(value) {
            this.setSelectedCalendarMode(value);
            this.forecastWeeksYieldApplied = [];
            this.forecastWeeksProfileApplied = [];
        }
    },
    created(){
        
    },
    mounted() {
        // make sure component values reflect the store
        this.profileValues = this.showProfileValues;
        this.yieldValues= this.showYieldValues;
        this.allActiveLocations= this.showAllActiveLocations;
    }
}
</script>
<style scoped>
.flex-column {
    flex-direction: column!important;
}

.flex-row {
    flex-direction: row!important;
}

.d-flex {
    display: flex!important;
}

.flex-grow-1 {
    flex-grow: 1!important;
}

.flex-grow-0 {
    flex-grow: 0!important;
}
</style>